import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreinamentoComponent } from './treinamento.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '../../translate-module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CompanyService} from '../../services/company.service';
import { AppDataService } from '../../services';
import { PainelAlunoModule } from '../painel-aluno/painel-aluno.module';
import { MeusCursosModule } from '../Meus-Cursos/meus-cursos.module';
import { PainelFinanceiroModule } from '../painel-financeiro/painel-financeiro.module';
import { DuvidasModule } from '../duvidas/duvidas.module';
import { DepoimentosModule } from '../depoimentos/depoimentos.module';
import { MeusCertificadosModules } from '../Meus-Certificados/meus-certificados.module';

@NgModule({
  declarations: [
    TreinamentoComponent,


  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    PainelAlunoModule,
    MeusCursosModule,
    PainelFinanceiroModule,
    DuvidasModule,
    DepoimentosModule,
    MeusCertificadosModules,

    BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),


  ],
  providers: [
    CompanyService,
    AppDataService


  ],
  exports: [
    TreinamentoComponent
  ]
})
export class TreinamentoModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/treinamento/treinamento.module.ts